<template>
  <el-tabs
    v-model="activeTab"
    tab-position="left"
    class="ehr-tab-wrapper"
    style="height: 100%"
  >
    <el-tab-pane
      v-for="section in data.tabTitleList"
      :key="section.prop"
      :label="section.label"
      :name="section.prop"
    >
      <div class="cards-container">
        <!-- 描述类型数据 -->
        <template v-if="hasDescription(section)">
          <div class="ehr-card">
            <div
              v-for="(item, idx) in data[section.prop].descriptionTitle"
              :key="idx"
              class="card-row"
            >
              <div class="label">{{ item.label }}</div>
              <div class="value">
                {{
                  data[section.prop].descriptionData[item.prop] ||
                  "Not Available"
                }}
              </div>
            </div>
          </div>
        </template>

        <!-- 表格类型数据 -->
        <template v-if="hasTable(section)">
          <div
            v-for="(rowData, idx) in data[section.prop].tableData"
            :key="idx"
            class="ehr-card"
          >
            <div
              v-for="(column, cIdx) in data[section.prop].tableTitle"
              :key="cIdx"
              class="card-row"
            >
              <div class="label">{{ column.label }}</div>
              <div class="value" :class="{ tag: column.uiType === 'tag' }">
                {{ rowData[column.prop] || "Not Available" }}
              </div>
            </div>
          </div>
        </template>

        <!-- 空状态 -->
        <template
          v-if="
            !hasDescription(section) &&
            (!hasTable(section) || !data[section.prop].tableData.length)
          "
        >
          <div class="ehr-card empty-card">
            <div class="empty-text">No data available</div>
          </div>
        </template>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "MedicalInfoTabs",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: this.data.tabTitleList?.[0]?.prop || "",
    };
  },
  methods: {
    hasDescription(section) {
      const sec = this.data[section.prop];
      return sec?.descriptionTitle?.length > 0;
    },
    hasTable(section) {
      const sec = this.data[section.prop];
      return sec?.tableTitle?.length > 0;
    },
  },
};
</script>

<style scoped>
.ehr-tab-wrapper {
  background: #fff;
}

.cards-container {
  padding: 16px;
  /* background-color: #eeeefa; */
  border-radius: 8px;
  margin-bottom: 16px;
}

.ehr-card {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: none;
}

.empty-card {
  text-align: center;
}

.empty-text {
  color: #6b7280;
  font-size: 14px;
}

.card-row {
  margin-bottom: 16px;
}

.label {
  font-size: 14px;
  color: #9898ab;
  margin-bottom: 4px;
}

.value {
  font-size: 16px;
  color: #202224;
}

.tag {
  background-color: #e5e7eb;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}
</style>
